/**
 * strips the "-beta" part from the version
 * "semver" library does not handle it very well
 * ex: `semver.satisfies("5.2.1-beta.2", ">=4.0.0")` returns false
 * @param {string} [version]
 */
export function normalizeVersion(version) {
    if (!version?.includes('-beta')) return version;
    return version.split('-beta')[0];
}
